import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';
import { getCurrencySymbol } from '../../../utils/getCurrencySymbol';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  details__header: {
    width: '15%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomWidth: 1,
  },
  table__content: {
    width: '15%',
    marginTop: 5,
    marginBottom: 5,
  },
  customer__name__content__header: {
    width: '20%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  customer__name__content: {
    width: '20%',
    marginTop: 5,
    marginBottom: 5,
  },
  customer__name: {
    marginLeft: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    paddingRight: 10,
  },
  tableRow__heading: {
    margin: 'auto',
    flexDirection: 'row',
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    marginLeft: 5,
    marginRight: 5,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  main__content: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
    color: 'rgba(84, 91, 125, 1)',
  },
  sub__content: {
    color: 'rgba(109, 125, 139, 1)',
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginTop: '8px',
  },
  display__flex__column: {
    display: 'flex',
    flexDirection: 'column',
  },
  amount__textAlign: {
    textAlign: 'right',
  },
  font__size__weight__12__4: {
    fontSize: '12px',
    fontWeight: '400',
  },
  text__color__light: {
    color: 'rgba(109, 125, 139, 1)',
  },
  type__voided: {
    color: 'rgba(179, 179, 179, 1)',
    textDecoration: 'line-through',
  },
});

// const historyData = [
//   {
//     createdAt: [{ date: '2024-08-21' }, { time: '09:22 AM' }],
//     customer: [
//       { customerName: 'Cameron Williamson' },
//       { phoneNumber: '(406) 555-0120' },
//     ],
//     paymentMethod: 'Card Present',
//     amount: 300.658,
//   },
//   {
//     createdAt: [{ date: '2024-08-21' }, { time: '02:22 AM' }],
//     customer: [
//       { customerName: 'Jeff Bezos' },
//       { phoneNumber: '(406) 555-0120' },
//     ],
//     paymentMethod: 'Virtual Terminal',
//     amount: 100.658,
//   },
// ];

export default function TransactionHistory({ addCommasToNumber, data }) {
  const { payments = [], customer = '' } = data;
  console.log('>>>payments', payments);
  return (
    <>
      <View>
        <Text style={styles.main__heading}>Transaction History</Text>
      </View>
      {true ? (
        <View style={styles.table}>
          <View style={styles.tableRow__heading} wrap={false}>
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Date</Text>
            </View>
            <View style={styles.customer__name__content__header}>
              <Text style={styles.tableCellHeader}>Name</Text>
            </View>
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Payment Method</Text>
            </View>
            <View style={styles.customer__name__content__header}>
              <Text style={styles.tableCellHeader}>Info</Text>
            </View>
            <View style={styles.details__header}>
              <Text style={[styles.tableCellHeader]}>Amount</Text>
            </View>
            <View style={styles.details__header}>
              <Text style={[styles.tableCellHeader]}>Type</Text>
            </View>
          </View>

          {[...payments]?.map((payment, index) => {
            return (
              <View style={styles.tableRow} key={index++} wrap={false}>
                <View style={styles.table__content}>
                  <View style={styles.display__flex__column}>
                    <Text
                      style={[
                        styles.tableCell,
                        styles.main__content,
                        payment.voided && styles.type__voided,
                      ]}
                    >
                      {moment(payment?.createdAt).format('YYYY-MM-DD')}
                    </Text>
                  </View>
                </View>
                <View style={styles.customer__name__content}>
                  <View style={styles.display__flex__column}>
                    <Text
                      style={[
                        styles.customer__name,
                        payment.voided && styles.type__voided,
                      ]}
                    >
                      {customer?.name || '-'}
                    </Text>
                    <Text
                      style={[
                        styles.tableCell,
                        styles.sub__content,
                        payment.voided && styles.type__voided,
                      ]}
                    >
                      {customer?.phone || '-'}
                    </Text>
                  </View>
                </View>
                <View style={styles.table__content}>
                  <Text
                    style={[
                      styles.tableCell,
                      styles.main__content,
                      payment.voided && styles.type__voided,
                    ]}
                  >
                    {payment?.terminalMethod
                      ? payment?.terminalMethod?.terminalMethod?.name +
                        '\n' +
                        '(' +
                        payment?.terminalMethod?.name +
                        ')'
                      : payment?.paymentMethod || 'N/A'}
                  </Text>
                </View>
                <View style={styles.customer__name__content}>
                  <Text
                    style={[
                      styles.tableCell,
                      // styles.amount__textAlign,
                      styles.main__content,
                      payment.voided && styles.type__voided,
                    ]}
                  >
                    {payment?.paymentMethod?.toLowerCase() === 'cash' ? (
                      '--'
                    ) : payment?.paymentMethod?.toLowerCase() === 'card' ? (
                      <View>
                        <View
                          style={[
                            styles.cardHolderName,
                            payment.voided && styles.type__voided,
                          ]}
                        >
                          {payment.cardHolderName ?? '--'}
                        </View>
                        <View style={[styles.tableCell, styles.sub__content]}>
                          <Text>{payment.methodType} </Text>
                          <View style={['d-flex']}>
                            {payment.cardType && (
                              <Text
                                style={payment.voided && styles.type__voided}
                              >
                                {payment.cardType}
                              </Text>
                            )}
                          </View>
                          <View>
                            {payment.reference && (
                              <Text
                                style={payment.voided && styles.type__voided}
                              >
                                {' '}
                                ({payment?.reference || '--'})
                              </Text>
                            )}
                          </View>
                        </View>
                      </View>
                    ) : payment?.paymentMethod?.toLowerCase() === 'check' ? (
                      <View>
                        <Text
                          style={[
                            styles.cardHolderName,
                            payment.voided && styles.type__voided,
                          ]}
                        >
                          {payment.cardHolderName ?? '--'}
                        </Text>
                        {'\n'}
                        {payment.reference && (
                          <Text
                            style={[
                              styles.tableCell,
                              styles.sub__content,
                              payment.voided && styles.type__voided,
                            ]}
                          >
                            {payment?.cardType ?? '--'}
                            {'\n'}({payment.reference ?? '--'})
                          </Text>
                        )}
                      </View>
                    ) : payment?.paymentTerminalMethodId === 1 ||
                      payment?.paymentTerminalMethodId === 2 ||
                      payment?.paymentTerminalMethodId === 3 ? (
                      <View>
                        <Text
                          style={[
                            styles.cardHolderName,
                            payment.voided && styles.type__voided,
                          ]}
                        >
                          Torque Pay
                        </Text>
                        {'\n'}
                        <Text
                          style={[
                            styles.tableCell,
                            styles.sub__content,
                            payment.voided && styles.type__voided,
                          ]}
                        >
                          {payment?.paymentTerminalMethodId === 1
                            ? '(Card Present)'
                            : payment?.paymentTerminalMethodId === 3
                            ? '(Card Not Present)'
                            : '(Payment Link)'}
                        </Text>
                      </View>
                    ) : (
                      <View>
                        <View style={payment.voided && styles.type__voided}>
                          {payment.paymentMethod}
                        </View>
                        <View
                          style={[
                            styles.font__size__weight__12__4,
                            styles.text__color__light,
                          ]}
                        >
                          {/* {`(${payment?.methodType})`} */}
                        </View>
                      </View>
                    )}
                  </Text>
                </View>
                <View style={styles.table__content}>
                  <Text
                    style={[
                      styles.tableCell,
                      // styles.amount__textAlign,
                      styles.main__content,
                      payment.voided && styles.type__voided,
                    ]}
                  >
                    {getCurrencySymbol()}
                    {addCommasToNumber(
                      Math.round((+payment?.paidAmount || 0) * 100) / 100,
                    )}
                  </Text>
                </View>
                <View style={styles.table__content}>
                  <Text
                    style={[
                      styles.tableCell,
                      styles.main__content,
                      payment.voided && styles.type__voided,
                    ]}
                  >
                    {payment.voided
                      ? 'Voided'
                      : payment.paymentType === 1 || payment.paymentType === 3
                      ? 'Paid'
                      : 'Refunded'}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      ) : (
        <Text />
      )}
    </>
  );
}
